import { render, staticRenderFns } from "./attribute-tab-partial.vue?vue&type=template&id=0a8a837d"
import script from "./attribute-tab-partial.vue?vue&type=script&lang=js"
export * from "./attribute-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports